import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    KeyboardDateTimePicker,
    KeyboardTimePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import indigo from '@material-ui/core/colors/indigo';
import { createTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import Constant from '@/common/constant/Constant';
import moment from 'moment';

const defaultMaterialTheme = createTheme({
    palette: {
        primary: indigo,
    },
});

function MuiDateTimePicker(props) {
    const { control } = useFormContext();
    const { name, value, defaultValue, label, required, errorlist, onChange, typePicker, format } =
        props;
    let isError = false;
    let errorMessage = '';
    if (errorlist && errorlist.hasOwnProperty(name)) {
        isError = true;
        errorMessage = errorlist[name].message;
    }

    const inputRef = React.useRef();
    const handleOnclick = () => {
        inputRef.current.focus();
    }

    let maxDate = moment().add(10, 'years').format('YYYY-MM-DD');

    const getComponentPicker = (field) => {
        let componentPicker;
        switch (typePicker) {
            case Constant.COMPONENT_DATETIME_PICKER.DATE_TIME_PICKER:
                componentPicker = (
                    <KeyboardDateTimePicker
                        {...field}
                        defaultValue={defaultValue ? defaultValue : ''}
                        value={value}
                        InputLabelProps={{
                            className: required ? 'required-label' : '',
                            required: required || false,
                        }}
                        inputVariant="outlined"
                        format={format}
                        minDate={new Date('1900-01-01')}
                        maxDate={maxDate}
                        error={isError}
                        helperText={errorMessage}
                        onChange={(e) => onChange(e)}
                        inputRef={inputRef}
                        onClick={handleOnclick}
                        {...props}  
                    />
                );
                break;
            case Constant.COMPONENT_DATETIME_PICKER.DATE_PICKER:
                componentPicker = (
                    <KeyboardDatePicker
                        className="field-date-picker"
                        {...field}
                        defaultValue={defaultValue ? defaultValue : ''}
                        value={value}
                        InputLabelProps={{
                            className: required ? 'required-label' : '',
                            required: required || false,
                        }}
                        inputVariant="outlined"
                        format={format}
                        minDate={new Date('1900-01-01')}
                        maxDate={maxDate}
                        error={isError}
                        helperText={errorMessage}
                        onChange={(e) => onChange(e)}
                        inputRef={inputRef}
                        onClick={handleOnclick}
                        {...props}
                    />
                );
                break;
            case  Constant.COMPONENT_DATETIME_PICKER.TIME_PICKER:
                componentPicker = (
                    <KeyboardTimePicker
                        className="field-date-picker"
                        {...field}
                        defaultValue={defaultValue ? defaultValue : ''}
                        value={value}
                        InputLabelProps={{
                            className: required ? 'required-label' : '',
                            required: required || false,
                        }}
                        inputVariant="outlined"
                        format={format}
                        error={isError}
                        helperText={errorMessage}
                        onChange={(e) => onChange(e)}
                        inputRef={inputRef}
                        onClick={handleOnclick}
                        {...props}
                    />
                );
                break;
            default:
        }

        return componentPicker;
    };

    return (
        <Controller
            control={control}
            name={name}
            label={label}
            fullWidth={true}
            {...props}
            render={({ field }) => {
                return (
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <ThemeProvider theme={defaultMaterialTheme}>
                            {getComponentPicker(field)}
                        </ThemeProvider>
                    </MuiPickersUtilsProvider>
                );
            }}
        />
    );
}

export default MuiDateTimePicker;
